"use client";

import { useEffect } from "react";
import { ADSENSE_INLINE_ONLY } from "@/components/nitro/config";

interface Props {
  slot: string;
}

export default function BaseRelatedDisplayAd({ slot }: Props) {
  useEffect(() => {
    if (ADSENSE_INLINE_ONLY) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {}
  }, []);

  if (ADSENSE_INLINE_ONLY) return null;

  return (
    <div>
      <ins
        className="adsbygoogle"
        style={{ display: "block", textAlign: "center" }}
        data-ad-client={process.env.NEXT_PUBLIC_ADS_CLIENT}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}